import { FetchNextPageOptions, InfiniteQueryObserverResult } from "@tanstack/react-query";
import _Scroller from "react-infinite-scroller";
import { Box, CircularProgress } from "@mui/material";
import { ComponentType } from "react";

import { text } from "@/modules/irohana-components/theme/colors";
import { FCC } from "@/modules/irohana-components/types/common";

// Workaround: react-infinite-scroller types incompatible with React 18
const Scroller = _Scroller as unknown as ComponentType<{
  loadMore: () => void;
  hasMore: boolean;
  loader: React.ReactNode;
  children: React.ReactNode;
}>;

export type TInfiniteScrollProps = {
  loadMore: (options?: FetchNextPageOptions) => Promise<InfiniteQueryObserverResult | void>;
  hasMore: boolean;
};

export const InfiniteScroll: FCC<TInfiniteScrollProps> = ({ children, hasMore, loadMore }) => {
  return (
    <Scroller
      loadMore={() => loadMore()}
      hasMore={hasMore}
      loader={
        <Box textAlign="center">
          <CircularProgress size={20} sx={{ color: text.disable }} />
        </Box>
      }
    >
      {children}
    </Scroller>
  );
};
